import { render, staticRenderFns } from "./Battery.vue?vue&type=template&id=222a353a&scoped=true&"
import script from "./Battery.vue?vue&type=script&lang=ts&"
export * from "./Battery.vue?vue&type=script&lang=ts&"
import style0 from "./Battery.vue?vue&type=style&index=0&id=222a353a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a353a",
  null
  
)

export default component.exports